// Attribution build so CLS reports which element/selector actually shifted
// (metric.attribution.largestShiftTarget), instead of just a number with no
// way to trace it back to the offending component.
const reportWebVitals = (onPerfEntry) => {
  if (!(onPerfEntry instanceof Function)) return;
  import('web-vitals/attribution').then(({ onCLS, onINP, onLCP, onFCP, onTTFB }) => {
    onCLS(onPerfEntry, { reportAllChanges: false });
    onINP(onPerfEntry);
    onLCP(onPerfEntry);
    onFCP(onPerfEntry);
    onTTFB(onPerfEntry);
  });
};

export default reportWebVitals;
